import React from 'react';
import VideoPlayer from '../../../../../Components/WebChat/Conversation/VideoPlayer';
import { useMediaProgress } from '../../../../utils';
import PropTypes from 'prop-types';

const VideoPreview = ({ media, channelId, index, thumbImage, isActive, videoControls }) => {
   const { content, messageId } = media;
   const { media: mediaData = {} } = content || {};
   const { caption, originalHeight, originalWidth, local_path, is_uploading, is_downloaded, thumb_image: thumb_image_data } = mediaData;
   const { downloadMedia } = useMediaProgress({
      channelId,
      is_uploading,
      is_downloaded,
      messageId,
      autoDownload: true,
      fileSave: false,
      local_path,
   });
   const thumb_image = thumb_image_data
      ? `data:image/jpeg;base64,${thumb_image_data}`
      : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAACqCAYAAADMWNgmAAAABHNCSVQICAgIfAhkiAAADxBJREFUeF7tnfuOFEUUh0tBQOQWNggEEOR+SSCIBqKLxoRsjE/gk/gQvog+ASEbEsIlZDfAH5Cg3EQQjEHl4gUISsD5VXI2xezszDDV01NV/XWycdnpqj7nO9XfVlWPO2+8fPlyjXPum9bXROtrdeuLAwIQgEBuBO61Ap5sfX39Rktq37a++Sq3DIgXAhCAQAcC30lqj1ovLAcPBCAAgQII/CmpvSwgEVKAAAQg4AkgNQYCBCBQFAGkVlQ5SQYCEEBqjAEIQKAoAkitqHKSDAQggNQYAxCAQFEEkFpR5SQZCEAAqTEGIACBogggtaLKSTIQgABSYwxAAAJFEUBqRZWTZCAAAaTGGIAABIoigNSKKifJQAACSI0xAAEIFEUAqRVVTpKBAASQGmMAAhAoigBSK6qcJAMBCCA1xgAEIFAUAaRWVDlJBgIQQGqMAQhAoCgCSK2ocpIMBCCA1BgDEIBAUQSQWlHlJBkIQACpMQYgAIGiCCC1ospJMhCAAFJjDEAAAkURQGpFlZNkIAABpMYYgAAEiiKA1IoqJ8lAAAJIjTEAAQgURQCpFVVOkoEABJAaY8ATuH79urt79657+vRpEkT27t3r1q9fn0QsBJEXAaSWV72GEu3U1JR78ODBUPqO6RSxxdBrbluk1tza+8y///57d+vWLf/9unXr/OxobGxsZFQ0Y9SXHYhtZKXI9sJILdvSxQf+/PlzNzk56TvatGmT2717d3ynkT20S03dIbZIqA1rjtQaVvAw3fv377vp6Wn/o4mJCTd//vyR0+gkNcQ28rJkFQBSy6pc1QZrUlu6dKk7fPhwtZ0P2NtcUkNsAwJtYDOk1sCiW8omtZUrV7pDhw4lQaKb1BBbEiVKPgiklnyJhhdgjlJDbMMbD6X0jNRKqeQAeeQqNcQ2QLEb1ASpNajY7anmLDXE1uCB2yN1pNbgsZG71BBbgwdvl9SRWoPHRQlSQ2wNHsBzpI7UGjwmSpEaYmvwIO6QOlJr8HgoSWqIrcEDuS11pNbgsVCa1BBbgwdzkDpSa/A4KFFqKuf4+LhbtmxZgyvb7NSRWoPrn6LUFNOgfwbJ/h7cwYMHR/qXRho8pJJIHaklUYbRBJGi1GJI2N+FQ2oxFPNvi9Tyr+HAGSC1gdHRMGECSC3h4gw7NKQ2bML0PwoCSG0U1BO5JlJLpBCEUSkBpFYpzrw6Q2p51Yto+yOA1PrjVORZSK3IsjY+KaTW4CGA1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xD4XAaTW4LGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xM7TT8bALAJIjUFRIgFmaiVWtc+ckFqfoDgtKwJILatyVRssUquWJ72lQQCppVGHkUSB1EaCnYsOmQBSGzLglLtHailXh9gGJYDUBiVXQDukVkARSWEWAaTW4EGB1Bpc/IJTR2oFF7dXakitFyFez5EAUsuxahXFjNQqAkk3SRFAakmVo95gkFq9vLlaPQSQWj2ck7wKUkuyLAQVSQCpRQLMuTlSy7l6xD4XAaTW4LGB1B'
   React.useEffect(() => {
      if (!local_path && isActive) {
         downloadMedia();
      }
   }, [local_path, isActive]);

   return (
      <div className="video-wrapper1" id={`video-player-${messageId}`}>
         {local_path ? (
            <VideoPlayer
               {...videoControls(local_path, messageId, thumb_image, isActive)}
               palyStatus={false}
               webWidth={originalWidth}
               webHeight={originalHeight}
               captionMargin={10}
               index={index}
               fileType={'video'}
            />
         ) : (
            <p>Loading video...</p>
         )}
         {caption && (
            <p className="legend image-caption" style={{ marginTop: '10px' }}>
               {caption}
            </p>
         )}
      </div>
   );
};

VideoPreview.propTypes = {
   media: PropTypes.shape({
      content: PropTypes.shape({ media: PropTypes.object }),
      messageId: PropTypes.string,
   }),
   channelId: PropTypes.string.isRequired,
   isActive: PropTypes.bool.isRequired,
   index: PropTypes.number.isRequired,
   thumbImage: PropTypes.string,
   videoControls: PropTypes.object,
};

export default VideoPreview;
